import { Component, OnInit } from "@angular/core";

@Component({
    selector: "app-llp-page",
    templateUrl: "./llp-page.component.html",
    styleUrls: ["./llp-page.component.css"],
    standalone: false
})
export class LlpPageComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
  showDemoForm = false;
  formSubmitted = false; // Flip and show thank you

  submitDemoForm(form) {
    if (form.valid) {
      this.formSubmitted = true;
      setTimeout(() => {
        // Optionally reset modal after a short duration
        // this.closeDemoModal();
      }, 3000); // Optional auto-close after 3s
    }
  }

  closeDemoModal() {
    this.showDemoForm = false;
    setTimeout(() => (this.formSubmitted = false), 400); // reset flip after modal closes
  }
}
